import React, { Component } from "react";
import { connect } from "react-redux";
import { getCompanyEvents } from "../../actions/bookingAction";
import {
  notification,
  IMAGE_BASE_URL,
  FRONTEND_BASE_URL,
  COMPANY_LOGO_BASE_URL,
  resolvePolicyLinkUrl,
  withRouter,
} from "../../utils/utility";
import isEmpty from "../../validation/is-empty";
// CompanyEventMeetoctoImage removed — default logo used instead
import { applyCompanyMarketingTools } from "../../utils/marketingTools";
import Loader from "../../components/Loader/Loader";
import logo from "../../assets/images/logo-new.svg";
import octoIcon from "../../assets/icons/octo_icon.svg";
import side_bar_foot_logo from "../../assets/bookingeventassets/assets/side_bar_foot_logo.svg";
import "./company-page.scss";

/* ── Venue icon helper ───────────────────────────────────────────── */
/* ── Inline SVG icon components ────────────────────────────────── */
const EmailIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const PhoneIconSvg = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2A19.79 19.79 0 013.07 4.18 2 2 0 015 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);
const MapPinIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);
const ClockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const UsersIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
  </svg>
);
const ShareIconSvg = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);
const MegaphoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8a2 2 0 000 4"/><path d="M6 8v4"/><path d="M3 6l15-2v12L3 14z"/><path d="M6 12v4a2 2 0 004 0v-4"/>
  </svg>
);

/* ── Venue icon (monochrome outline; inherits the detail text color) ── */
const VenueIconImg = ({ venue }) => {
  if (venue === "Phone Call") {
    return (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
    );
  }
  if (venue === "In-Person Meeting") {
    return (
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
      </svg>
    );
  }
  /* Online meetings — Google Meet, Zoom, Teams, GoTo, Others */
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
    </svg>
  );
};

/* ── Format badge label ──────────────────────────────────────────────
   1 = One-to-one → "1:1"
   2 = Group      → "<capacity>:1" (e.g. 6 people → "6:1")            */
const formatBadgeLabel = (item) => {
  if (!item) return "";
  if (Number(item.event_format_id) === 1) return "1:1";
  if (Number(item.event_format_id) === 2) {
    const n = Number(item.no_of_attendies) || 0;
    return n > 0 ? `${n}:1` : "Group";
  }
  const f = (item.event_format || "").toLowerCase();
  if (f.includes("one") || f.includes("1:1")) return "1:1";
  return f ? "Group" : "";
};

/* ═══════════════════════════════════════════════════════════════════
   Component
═══════════════════════════════════════════════════════════════════ */
class CompanyPage extends Component {
  state = {
    company: {},
    events: [],
    specialRibbon: null,
    isLoading: false,
  };

  componentDidMount() {
    const _this = this;
    const { router, getCompanyEvents } = this.props || {};
    const { params } = router || {};
    const { slug } = params || {};

    this.setState({ isLoading: true });
    getCompanyEvents({
      data: { slug },
      onSuccess: function (response) {
        _this.setState({
          isLoading:     false,
          company:       response.company,
          events:        response.events,
          specialRibbon: !isEmpty(response.special_ribbon)
            ? response.special_ribbon.special_announcement
            : null,
        });
        applyCompanyMarketingTools(response.seo);
      },
      onError: (error) => {
        _this.setState({ isLoading: false });
        notification.error(error?.response?.data?.message || "Failed to load company events.");
      },
    });
  }

  onBookNow = (eventURL) => {
    const { router } = this.props;
    const { navigate } = router || {};
    const { company } = this.state;
    navigate(`/booking/${company.business_id}/${eventURL}`);
  };

  onShareEvent = (eventURL) => {
    const { company } = this.state;
    const bookingUrl = `${FRONTEND_BASE_URL}booking/${company.business_id}/${eventURL}`;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(bookingUrl).then(() =>
        notification.success(`Booking link copied!`)
      );
    } else {
      const el = document.createElement("textarea");
      el.value = bookingUrl;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      notification.success(`Booking link copied!`);
    }
  };

  render() {
    const { company, events, specialRibbon, isLoading } = this.state;
    const privacyPolicyUrl     = resolvePolicyLinkUrl(company.privacy_policy);
    const cancellationPolicyUrl= resolvePolicyLinkUrl(company.cancellation_policy);
    const termsUrl             = resolvePolicyLinkUrl(company.terms_and_conditions);
    const hasPolicyLinks       = privacyPolicyUrl || cancellationPolicyUrl || termsUrl;

    return (
      <>
        <Loader isShowLoader={isLoading} />

        <div className="cp-page">

          {/* ── Top bar ──────────────────────────────────────── */}
          <header className="cp-topbar">
            <img src={logo} alt="MeetOcto" />
          </header>

          {/* ── Two-panel layout ─────────────────────────────── */}
          <div className="cp-layout">

            {/* ══ Left sidebar ═══════════════════════════════════ */}
            <aside className="cp-sidebar">
              <div className="cp-sidebar-card">

                {/* Company photo / banner */}
                {company.company_logo ? (
                  <img
                    className="cp-company-banner"
                    src={COMPANY_LOGO_BASE_URL + company.company_logo}
                    alt={company.company_name || "Company logo"}
                  />
                ) : (
                  <div className="cp-company-banner cp-company-banner--placeholder">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                  </div>
                )}

                {/* Company info */}
                <div className="cp-sidebar-body">
                  {company.company_name && (
                    <h2 className="cp-company-name">{company.company_name}</h2>
                  )}
                  {company.company_description && (
                    <p className="cp-company-desc">{company.company_description}</p>
                  )}

                  {/* Contact details */}
                  {(company.company_email || company.company_phone_no || company.company_address) && (
                    <div className="cp-contacts">
                      {company.company_email && (
                        <div className="cp-contact-row">
                          <EmailIcon />
                          <a href={`mailto:${company.company_email}`}>
                            {company.company_email}
                          </a>
                        </div>
                      )}
                      {company.company_phone_no && (
                        <div className="cp-contact-row">
                          <PhoneIconSvg />
                          <span>{company.company_phone_no}</span>
                        </div>
                      )}
                      {company.company_address && (
                        <div className="cp-contact-row">
                          <MapPinIcon />
                          <span>{company.company_address}</span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Policy links */}
                  {hasPolicyLinks && (
                    <nav className="cp-policies" aria-label="Legal">
                      {privacyPolicyUrl && (
                        <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className="cp-policy-link">
                          Privacy Policy
                        </a>
                      )}
                      {cancellationPolicyUrl && (
                        <a href={cancellationPolicyUrl} target="_blank" rel="noopener noreferrer" className="cp-policy-link">
                          Cancellation Policy
                        </a>
                      )}
                      {termsUrl && (
                        <a href={termsUrl} target="_blank" rel="noopener noreferrer" className="cp-policy-link">
                          Terms &amp; Conditions
                        </a>
                      )}
                    </nav>
                  )}
                </div>

                {/* Powered by footer */}
                <div className="cp-powered-by">
                  <span>Powered by</span>
                  <img src={side_bar_foot_logo} alt="Powered by MeetOcto" />
                </div>
              </div>
            </aside>

            {/* ══ Main content ════════════════════════════════════ */}
            <main className="cp-main">

              {/* Special ribbon */}
              {!isEmpty(specialRibbon) && (
                <div className="cp-ribbon">
                  <MegaphoneIcon />
                  <span>{specialRibbon}</span>
                </div>
              )}

              {/* Page header */}
              <div className="cp-main-header">
                {company.company_name && (
                  <p className="cp-brand-label">{company.company_name}</p>
                )}
                <h1 className="cp-main-title">Choose an event</h1>
                <p className="cp-main-sub">Select the meeting that works for you</p>
                {events.length > 0 && (
                  <span className="cp-event-count">{events.length} event{events.length !== 1 ? "s" : ""}</span>
                )}
              </div>

              {/* Events grid */}
              <div className="cp-events-grid">
                {events.length === 0 && !isLoading ? (
                  <div className="cp-empty">No events available at this time.</div>
                ) : (
                  events.map((item, index) => {
                    const fmtLabel   = formatBadgeLabel(item);
                    const isPaid     = item.is_event_paid === "E";
                    // Backend returns timeslot already formatted e.g. "5 Minutes" or "Customized"
                    const timeslot   = item.timeslot || "";

                    return (
                      <div className="cp-event-card" key={item.id || index}>
                        <div className="cp-card-body">

                          {/* Top: avatar + title + badges */}
                          <div className="cp-card-top">
                            <div className="cp-card-avatar">
                              {item.event_image ? (
                                <img
                                  src={IMAGE_BASE_URL + item.event_image}
                                  alt={item.event_title}
                                />
                              ) : (
                                <img
                                  src={octoIcon}
                                  alt="MeetOcto"
                                  style={{ width: "40px", height: "40px", objectFit: "contain" }}
                                />
                              )}
                            </div>
                            <div className="cp-card-title-group">
                              <h3 className="cp-card-title">{item.event_title}</h3>
                              <div className="cp-card-badges">
                                {fmtLabel && (
                                  <span className="cp-badge cp-badge--format">{fmtLabel}</span>
                                )}
                                <span className={`cp-badge ${isPaid ? "cp-badge--paid" : "cp-badge--free"}`}>
                                  {isPaid ? `$${item.event_fee}` : "Free"}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Description */}
                          {item.event_description ? (
                            <p
                              className="cp-card-desc"
                              dangerouslySetInnerHTML={{ __html: item.event_description }}
                            />
                          ) : null}

                          {/* Details */}
                          <div className="cp-card-details">
                            <div className="cp-card-detail">
                              <ClockIcon />
                              <span>{timeslot}</span>
                            </div>
                            {item.venue && (
                              <div className="cp-card-detail">
                                <VenueIconImg venue={item.venue} />
                                <span>{item.venue}</span>
                              </div>
                            )}
                            {item.event_format && (
                              <div className="cp-card-detail">
                                <UsersIcon />
                                <span>{item.event_format}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Card footer */}
                        <div className="cp-card-footer">
                          <button
                            type="button"
                            className="cp-btn-share"
                            onClick={() => this.onShareEvent(item.event_url)}
                          >
                            <ShareIconSvg />
                            Share
                          </button>
                          <button
                            type="button"
                            className="cp-btn-book"
                            onClick={() => this.onBookNow(item.event_url)}
                          >
                            View times →
                          </button>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </main>

          </div>{/* .cp-layout */}
        </div>{/* .cp-page */}
      </>
    );
  }
}

export default connect(null, {
  getCompanyEvents,
})(withRouter(CompanyPage));
